<div class="menu-item" (click)="onToggleClick($event)">
  <ng-container *ngIf="leadingIcon && !withSelectIcon">
    <svg-icon [name]="leadingIcon" class="leading-icon"></svg-icon>
  </ng-container>
  <ng-container *ngIf="withSelectIcon">
    <svg-icon [name]="'menu-checkmark-on'" *ngIf="active"></svg-icon>
    <svg-icon [name]="'empty-16'" *ngIf="!active"></svg-icon>
  </ng-container>
  <ng-container *ngIf="isToggle">
    <svg-icon [name]="'menu-checkmark-on'" *ngIf="toggleValue"></svg-icon>
    <svg-icon [name]="'empty-16'" *ngIf="!toggleValue"></svg-icon>
  </ng-container>

  <span class="menu-item-text">
    <ng-content></ng-content>
    <app-x-badge *ngIf="showNewBadge" color="gray" style="margin-left: 8px;">NEW</app-x-badge>
  </span>

  <svg-icon [name]="'caret-right-outline'" *ngIf="submenu"></svg-icon>
  <ng-container *ngIf="trailingIcon">
    <svg-icon [name]="trailingIcon" style="margin-left: 16px;"></svg-icon>
  </ng-container>
</div>
